<!-- Messages toggle -->
<button mat-icon-button (click)="openPanel()" #messagesOrigin>
  <mat-icon [svgIcon]="'mat_outline:message'"></mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>

  <div
    class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-100 sm:w-100 sm:rounded-2xl overflow-hidden shadow-lg">

    <!-- Header -->
    <div class="flex shrink-0 items-center justify-between py-4 pr-4 pl-6 bg-primary text-on-primary">
      <div class="sm:hidden -ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x'"></mat-icon>
        </button>
      </div>
      <!-- <div class="-ml-1 mr-3 hidden md:block" *ngIf="component === 'create'">
      <button mat-icon-button (click)="goToListView()">
        <mat-icon class="icon-size text-current" [svgIcon]="'mat_outline:arrow_back'"></mat-icon>
      </button>
    </div> -->
    <ng-container *transloco="let t">
      <div class="text-lg font-medium leading-10">{{ t('messages') }}</div>

      @if (component === 'list') {
        <div class="ml-auto">
          <button mat-icon-button [matTooltip]="t('refresh')" (click)="refresh()">
            <mat-icon class="icon-size-5 text-current" [svgIcon]="'mat_outline:refresh'"></mat-icon>
          </button>
        </div>
      }
      @if (component === 'list') {
        <div class="ml-4">
          <button mat-icon-button [matTooltip]="t('createMessage')" (click)="goToCreateView()">
            <mat-icon class="icon-size-5 text-current" [svgIcon]="'mat_outline:create'"></mat-icon>
          </button>
        </div>
      }
      @if (component === 'list') {
        <div class="ml-4">
          <button mat-icon-button [matTooltip]="showFilters ? t('closeFilters') : t('openFilters')" (click)="toggleFilters()">
            <mat-icon class="icon-size-5 text-current" [svgIcon]="showFilters ? 'heroicons_solid:filter' : 'heroicons_outline:filter'"></mat-icon>
          </button>
        </div>
      }
    </ng-container>
    @if (component === 'create') {
      <div class="-ml-1 mr-3">
        <button mat-icon-button (click)="goToListView()">
          <mat-icon class="icon-size text-current" [svgIcon]="'mat_outline:arrow_back'"></mat-icon>
        </button>
      </div>
    }
  </div>

  <!-- Content -->
  @if (showFilters) {
    <div class="flex flex-col flex-auto px-6 py-2 bg-gray-50 dark:bg-gray-800" animate.enter="slide-down" animate.leave="slide-up">
      <ng-container *transloco="let t">
        <mat-slide-toggle color="primary" class="ml-4 my-2" [formControl]="getControl('ackPending')">{{ t('ackPending') }}</mat-slide-toggle>
        <mat-slide-toggle color="primary" class="ml-4 my-2" [formControl]="getControl('rcPending')">{{ t('rcPending') }}</mat-slide-toggle>
      </ng-container>
    </div>
  }
  <div #container class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto overflow-x-hidden bg-card" (scroll)="onScroll($event)">
    <!-- Messages list -->
    @if (component === 'list') {
      <messages-list></messages-list>
    }

    <!-- Create message -->
    @if (component === 'create') {
      <create-message [message]="newMessage" (closePanel)="closePanel()" class="flex justify-center"></create-message>
    }
  </div>
</div>
</ng-template>